module.exports = __webpack_public_path__ + "img/02.89b31178.png";